import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import AdminEditButtons from '../EditButtons';
import AdminGroupEditMembersEditListItem from './MembersEditListItem';
import AdminGroupEditMembersEditSelect from './MembersEditSelect';

import ErrorBoundary from '../../ErrorBoundary';

const AdminGroupEditMembersEdit = ({
  group,
  usersLoading,
  handleRemoveMember,
  users,
  ...props
}) => {
  const intl = useIntl();

  const getUser = (userUuid) => users.find(u => (u.uuid === userUuid));

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper">
        <p>
          {intl.formatMessage({
            defaultMessage: 'Manage users in this Team. You can view, delete and add new users.',
          })}
        </p>
        <div className="group-members">
          <div className="group-members-add">
            <AdminGroupEditMembersEditSelect
              group={group}
              users={users}
              usersLoading={usersLoading}
              {...props}
            />
          </div>

          {!usersLoading && (
            <div className="users-list group-members-list">
              {group.users.map(u => (
                <AdminGroupEditMembersEditListItem
                  key={u}
                  user={getUser(u)}
                  handleRemove={handleRemoveMember}
                />
              ))}
            </div>
          )}
        </div>
      </div>
      <AdminEditButtons
        {...props}
        deleteText={intl.formatMessage({ defaultMessage: 'Delete Team' })}
      />
    </ErrorBoundary>
  );
};

AdminGroupEditMembersEdit.propTypes = {
  group: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  usersLoading: PropTypes.bool.isRequired,
  handleRemoveMember: PropTypes.func.isRequired,
};

export default AdminGroupEditMembersEdit;
